import { Messages } from "../../../../config/messages/messages";

export const vsmDrsSettings = {
	success: Messages.CREATED,
	error: Messages.DUPLICATED,
	validation: {
		drs_docs_per_page: [{ required: true, message: Messages.NOT_SELECTED }],
	},
};
